/* mc-header-website.js
   Version: 2.0.1
   
   Aenderungen 2.0.1:
   - Keine funktionalen Aenderungen
   - Keine funktionalen Aenderungen (Logik unveraendert)
   - Versionsnummer aktualisiert fuer Konsistenz
*/

(function () {
  function initSlider(root) {
    if (!root) return;

    var track = root.querySelector('.mchw__track');
    var slides = Array.from(root.querySelectorAll('.mchw__slide'));
    var dots = Array.from(root.querySelectorAll('.mchw__dot'));
    var btnPrev = root.querySelector('.mchw__nav--prev');
    var btnNext = root.querySelector('.mchw__nav--next');
    var viewport = root.querySelector('.mchw__viewport');

    if (!track || !slides.length || !viewport) return;

    var index = 0;
    var autoplay = viewport.dataset.autoplay === 'true' && slides.length > 1;
    var interval = parseInt(viewport.dataset.interval || '9000', 10);
    var honorReduced = viewport.dataset.reducedMotion === 'true';
    var enableKeyboard = viewport.dataset.keyboard === 'true';
    var sendGA = viewport.dataset.ga4 === 'true';
    var prefersReduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var sliderId = root.id || 'mchw-slider';
    var timer = null;
    var paused = false;

    function dl(eventName, params) {
      if (!sendGA) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        Object.assign(
          {
            event: eventName,
            slider_id: sliderId
          },
          params || {}
        )
      );
    }

    function setActiveState() {
      if (dots.length) {
        dots.forEach(function (d, i) {
          var active = i === index;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
          d.setAttribute('tabindex', active ? '0' : '-1');
        });
      }
      slides.forEach(function (s, i) {
        s.setAttribute('tabindex', i === index ? '0' : '-1');
      });
    }

    function scrollToIndex(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      var slide = slides[index];
      var left = slide.offsetLeft;

      track.scrollTo({ left: left, behavior: 'smooth' });
      setActiveState();

      dl('mchw_slide_view', {
        slide_index: index + 1,
        slide_title: (slide && slide.dataset.slideTitle) || ''
      });
    }

    function scheduleNext() {
      if (!(autoplay && !paused)) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        scrollToIndex(index + 1);
        scheduleNext();
      }, interval);
    }

    function startAuto() {
      if (!(autoplay && !paused)) return;
      clearTimeout(timer);
      scheduleNext();
      dl('mchw_autoplay_start', { slide_index: index + 1 });
    }

    function stopAuto() {
      clearTimeout(timer);
      dl('mchw_autoplay_stop', { slide_index: index + 1 });
    }

    function restartAuto() {
      stopAuto();
      startAuto();
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        dl('mchw_nav_click', { direction: 'prev', from_index: index + 1 });
        scrollToIndex(index - 1);
        restartAuto();
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', function () {
        dl('mchw_nav_click', { direction: 'next', from_index: index + 1 });
        scrollToIndex(index + 1);
        restartAuto();
      });
    }

    if (dots.length) {
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          dl('mchw_dot_click', { to_index: i + 1 });
          scrollToIndex(i);
          restartAuto();
        });

        d.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            scrollToIndex(index - 1);
            restartAuto();
          }
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            scrollToIndex(index + 1);
            restartAuto();
          }
        });
      });
    }

    slides.forEach(function (s, i) {
      s.addEventListener('click', function (e) {
        var a = e.target.closest('.mchw__btn');
        if (!a) return;
        dl('mchw_cta_click', {
          slide_index: i + 1,
          slide_title: s.dataset.slideTitle || '',
          cta_label: a.textContent.trim(),
          cta_url: a.getAttribute('href')
        });
      });
    });

    if (enableKeyboard) {
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          scrollToIndex(index - 1);
          restartAuto();
        }
        if (e.key === 'ArrowRight') {
          scrollToIndex(index + 1);
          restartAuto();
        }
      });
    }

    root.addEventListener('mouseenter', function () {
      paused = true;
      stopAuto();
      dl('mchw_pause');
    });

    root.addEventListener('mouseleave', function () {
      paused = false;
      startAuto();
      dl('mchw_resume');
    });

    root.addEventListener('focusin', function () {
      paused = true;
      stopAuto();
      dl('mchw_pause');
    });

    root.addEventListener('focusout', function () {
      paused = false;
      startAuto();
      dl('mchw_resume');
    });

    document.addEventListener('visibilitychange', function () {
      var shouldPause = document.hidden || (honorReduced && prefersReduced);
      if (shouldPause) {
        paused = true;
        stopAuto();
        dl('mchw_pause', { reason: 'visibilitychange' });
      } else {
        paused = false;
        startAuto();
        dl('mchw_resume', { reason: 'visibilitychange' });
      }
    });

    setActiveState();
    dl('mchw_slider_init', { slides: slides.length });

    if (autoplay && !(honorReduced && prefersReduced)) {
      startAuto();
    }

    scrollToIndex(0);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    document.querySelectorAll('.mchw').forEach(function (root) {
      initSlider(root);
    });
  });
})();
